import pulse from '@finn-no/pulse-sdk';
import type { TrackerData } from '@finn-no/pulse-sdk/dist/types';
import type {
    PulseTracking,
    ResultEntry,
    Vertical,
} from '@schibsted-nmp/search-frontend-clients/quest';
import type { Layout } from '../components/results/layout/LayoutStore';

export function trackPageView(
    tracking: PulseTracking,
    layout: Layout,
    url: string,
) {
    const trackerData: TrackerData = {
        ...tracking,
        object: {
            ...tracking.object,
            layout: layout === 'list' ? 'List' : 'Grid',
            url,
        },
    };
    pulse.trackPageView(trackerData);
}

export function trackAdClick(
    ad: ResultEntry,
    position: number,
    tracking: PulseTracking,
    vertical?: Vertical,
) {
    const trackerData: TrackerData = {
        type: 'Click',
        intent: 'Open',
        name: 'Search result clicked',
        object: {
            type: 'ListingItem',
            id: `classified:${ad.id}`,
            name: 'Search result',
            rank: position,
            query: tracking.object.filters?.query,
            selectionFilters: tracking.object.selectionFilters,
            isTopPositionPremiumFeature: false,
        },
        target: {
            type: 'ClassifiedAd',
            id: ad.id,
            name: `${ad.heading}`,
            category: 'n/a',
            contentId: ad.id,
        },
    };

    // TODO: Move tracking for clothing size to search-quest
    const isMarketplace = vertical?.includes('BAP');
    if (isMarketplace && trackerData.object) {
        trackerData.object.items = [
            {
                type: 'MarketplaceItem',
                id: `classified:${ad.id}`,
                size: ad.extras
                    .some((extra) => extra.id === 'clothing_size')
                    .toString(),
            },
        ];
    }

    pulse.trackEvent(trackerData);
}

export function trackAdInscreen(
    ad: ResultEntry, // eslint-disable-line @typescript-eslint/no-unused-vars
    position: number, // eslint-disable-line @typescript-eslint/no-unused-vars
    tracking: PulseTracking, // eslint-disable-line @typescript-eslint/no-unused-vars
) {
    if (process.env.NODE_ENV === 'development') {
        console.log('inscreen tracking not implemented');
    }
}
